import {
  base_colorAction,
  base_colorContentBorder,
  base_colorRaisedSurface,
  grey450,
  tag_colorTagSevereText,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_family_weight_regular,
  font_size_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: ${spacing(3)};
  padding: ${spacing(5)};
  border: 1px solid ${base_colorContentBorder};
  border-radius: ${spacing(3)};
  background: ${base_colorRaisedSurface};

  .UsageMeterCard-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }

  .UsageMeterCard-title {
    font-family: ${font_family_weight_medium};
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: ${text_colorTextSecondary};
  }

  .UsageMeterCard-count-row {
    display: flex;
    align-items: baseline;
    gap: ${spacing(1)};
  }

  .UsageMeterCard-count {
    font-family: ${font_family_weight_medium};
    font-size: 28px;
    font-weight: 500;
    color: ${text_colorTextPrimary};
    font-variant-numeric: tabular-nums;
  }

  .UsageMeterCard-limit {
    font-family: ${font_family_weight_regular};
    font-size: 15px;
    font-weight: 400;
    color: ${text_colorTextSecondary};
  }

  .UsageMeterCard-bar {
    height: ${spacing(2)};
    border-radius: ${spacing(1)};
    overflow: hidden;
    background: ${grey450};
  }

  .UsageMeterCard-bar-fill {
    height: 100%;
    border-radius: ${spacing(1)};
    background: ${base_colorAction};
    transition: width 300ms;
  }

  @media (prefers-reduced-motion: reduce) {
    .UsageMeterCard-bar-fill {
      transition: none;
    }
  }

  &.is-critical .UsageMeterCard-bar-fill {
    background: ${tag_colorTagSevereText};
  }

  .UsageMeterCard-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: ${font_size_sm};
  }

  .UsageMeterCard-sublabel {
    font-family: ${font_family_weight_regular};
    font-weight: 400;
    color: ${text_colorTextSecondary};
  }

  .UsageMeterCard-cta {
    font-family: ${font_family_weight_medium};
    font-weight: 500;
    color: ${base_colorAction};
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }

    &:focus-visible {
      outline: 2px solid ${base_colorAction};
      outline-offset: 2px;
      border-radius: 2px;
    }
  }
`
